import { render, staticRenderFns } from "./index.vue?vue&type=template&id=454a6c6b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/notice_center.css?vue&type=style&index=0&id=454a6c6b&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454a6c6b",
  null
  
)

export default component.exports